/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeactivateProceedingParticipantRequest
 */
export interface DeactivateProceedingParticipantRequest {
    /**
     * 
     * @type {string}
     * @memberof DeactivateProceedingParticipantRequest
     */
    reason: string;
}

/**
 * Check if a given object implements the DeactivateProceedingParticipantRequest interface.
 */
export function instanceOfDeactivateProceedingParticipantRequest(value: object): value is DeactivateProceedingParticipantRequest {
    if (!('reason' in value) || value['reason'] === undefined) return false;
    return true;
}

export function DeactivateProceedingParticipantRequestFromJSON(json: any): DeactivateProceedingParticipantRequest {
    return DeactivateProceedingParticipantRequestFromJSONTyped(json, false);
}

export function DeactivateProceedingParticipantRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeactivateProceedingParticipantRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'reason': json['reason'],
    };
}

export function DeactivateProceedingParticipantRequestToJSON(json: any): DeactivateProceedingParticipantRequest {
    return DeactivateProceedingParticipantRequestToJSONTyped(json, false);
}

export function DeactivateProceedingParticipantRequestToJSONTyped(value?: DeactivateProceedingParticipantRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'reason': value['reason'],
    };
}

